// extracted by mini-css-extract-plugin
export default {"section":"Instagram_section__+xCfi","title":"Instagram_title__mjI+g","link":"Instagram_link__QsQDG","imageWrapper":"Instagram_imageWrapper__XXwlR","image":"Instagram_image__e+k78"};